import { useEffect, useRef } from "react";

export default function useOutsideDivAction(
  ref: React.MutableRefObject<HTMLDivElement | null | undefined>,
  cb: (e: MouseEvent) => void = () => null
) {
  const callbackRef = useRef<typeof cb>();
  callbackRef.current = cb;
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        ref.current &&
        !ref.current.contains(event.target as Node) &&
        callbackRef.current
      ) {
        callbackRef.current(event);
      }
    }

    // Bind the event listener
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [ref, callbackRef]);
}
